module.exports = __webpack_public_path__ + "img/gch2.e2c4b5d6.png";